/* eslint-disable no-console -- Mock utility with intentional development-only console output */
/**
 * Mock Zebra Browser Print for development/testing
 *
 * DISABLED by default - add ?zebra-mock=true to URL to activate
 * Import in main.tsx: import './utils/zebraMock';
 */

// Mock is DISABLED by default
// Use ?zebra-mock=true in URL to enable
const urlParams = new URLSearchParams(window.location.search);
const enableMock = urlParams.get('zebra-mock') === 'true';

if (import.meta.env.DEV && enableMock) {
  const hadBrowserPrint = !!window.BrowserPrint;

  if (hadBrowserPrint) {
    console.log('[Dev] Real Zebra Browser Print detected - overriding with mock');
  } else {
    console.log('[Dev] Initializing Mock Zebra Browser Print');
  }

  // Fix 10: Complete mock device with all required BrowserPrint.Device properties
  const mockPrinter: BrowserPrint.Device = {
    name: 'Mock Zebra ZD421 (Dev)',
    connection: 'usb',
    uid: 'dev-mock-zebra-1',
    deviceType: 'printer',
    manufacturer: 'Zebra Technologies',
    send: (zplData: string, onSuccess: () => void, _onError: (error: string) => void) => {
      console.log('[Mock Print] Sending ZPL to printer:');
      console.log(zplData.substring(0, 200) + (zplData.length > 200 ? '...' : ''));

      // Simulate print delay (1-2 seconds)
      const delay = 1000 + Math.random() * 1000;
      setTimeout(() => {
        console.log('[Mock Print] Success!');
        onSuccess();
      }, delay);
    },
    sendThenRead: (_cmd: string, onSuccess: (response: string) => void, _onError: (error: string) => void) => {
      // Mock ~HQES status response (all OK, 100 chars of '0')
      setTimeout(() => {
        onSuccess('0'.repeat(100));
      }, 100);
    },
    read: (callback: (data: string) => void) => {
      setTimeout(() => {
        callback('');
      }, 100);
    },
  };

  // Mock BrowserPrint global (force override)
  window.BrowserPrint = {
    getDefaultDevice: (
      _type: 'printer' | 'scanner',
      success: (device: BrowserPrint.Device | null) => void,
    ) => {
      console.log('[Mock] getDefaultDevice called');
      setTimeout(() => {
        console.log('[Mock] Returning mock printer to getDefaultDevice');
        success(mockPrinter);
      }, 100);
    },
    getLocalDevices: (
      success: (devices: BrowserPrint.Device[]) => void,
      _error?: (errorMsg: string) => void,
      _type?: 'printer' | 'scanner',
    ) => {
      console.log('[Mock] getLocalDevices called');
      setTimeout(() => {
        console.log('[Mock] Returning 1 mock printer to getLocalDevices');
        success([mockPrinter]);
      }, 100);
    },
    getApplicationConfiguration: (
      success: (config: BrowserPrint.ApplicationConfiguration) => void,
    ) => {
      setTimeout(() => {
        success({
          version: '3.0.216-mock',
          build_date: '2024-01-01',
          operating_system: 'mock',
        });
      }, 100);
    },
    convert: (binary: string) => btoa(binary),
  };

  console.log('[Dev] Mock Zebra Browser Print initialized');
  console.log('[Dev] Mock printer:', mockPrinter.name);
  console.log('[Dev] Enable autoprint: localStorage.setItem("zebra-autoprint", "true")');
  console.log('[Dev] Mock is enabled via ?zebra-mock=true in URL');
}
